export enum EndpointsMobiQueryKeys {
  Check = '/paybal/sdk/check',
  Pay = '/paybal/sdk/pay',
  TokenizeCheck = '/tokenization/submit',
  TokenizationCommit = '/tokenization/commit',
  GetLogo = '/wallet/logo',
}

export const wallet = 'wallet';
